import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InfoCommerce, TaxValidation, TypePerson, TypePersonOption, UploadScreenTaxInfo } from './model/tax-validation';
import { SesionService } from 'src/app/core/service/sesion.service';
import { Subscription } from 'rxjs';
import {
  FileDto,
  FileSave,
  UploadScreenInfo,
} from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { FileUploadService } from '../file-upload/service/file-upload.service';
import { TaxValidationService } from './service/tax-validation.service';
import { PotentialCustomer } from '../potential-customer/model/potential-customer';
import { noEmojisValidator } from 'src/app/core/service/utils/regex-list.regex';
import { FilePresignUrlUploadService } from 'src/app/shared/components/atoms/file-upload-component/service/file-upload-component.service';

@Component({
  selector: 'app-tax-validation',
  templateUrl: './tax-validation.component.html',
  styleUrls: ['./tax-validation.component.scss'],
})
export class TaxValidationComponent implements OnInit {
  taxForm: FormGroup;
  submitted: boolean;
  categorizedAfip: boolean = false;
  loading: boolean;
  rucNotEnrolled: boolean;
  rucNotRegistered: boolean;
  sessionData: TaxValidation | null;
  potentialCustomerData: PotentialCustomer | null;
  state: string = '';
  warningCuitText: string = '';
  isDuplicated: boolean = false;
  infoCommerce: InfoCommerce | undefined;
  @Output()
  onComplete = new EventEmitter<number>();
  rucSubscription: Subscription = new Subscription();
  @Output()
  onBack = new EventEmitter();
  validateOcrCount: number = 0;
  ocrError: boolean = false;
  personOption: any = TypePersonOption;
  typePerson: string = '';
  @ViewChild('errorDiv') errorDiv: ElementRef | undefined;
  private bucketSubscription: Subscription | undefined;

  constructor(
    private readonly fb: FormBuilder,
    private readonly sesion: SesionService,
    private readonly fileService: FileUploadService,
    private readonly taxService: TaxValidationService,
    private readonly serviceUploadFile: FileUploadService,
    private readonly bucketService: FilePresignUrlUploadService,
  ) {
    this.submitted = false;
    this.loading = false;
    this.rucNotEnrolled = false;
    this.rucNotRegistered = false;
    this.sessionData = this.sesion.getItem('tax_validation');
    this.potentialCustomerData = this.sesion.getItem('potential_customer');
    this.taxForm = this.fb.group({
      socialReason: [this.sessionData ? this.sessionData.socialReason : '', [Validators.required, Validators.maxLength(40), noEmojisValidator]],
      ci: [this.sessionData ? this.sessionData.ci : ''],
      fileFrontCi: [''],
      fileBackCi: [''],
      name: [this.sessionData ? this.sessionData.name : ''],
      surname: [this.sessionData ? this.sessionData.surname : ''],
      ruc: [this.sessionData ? this.sessionData.ruc : ''],
      typePerson: [this.sessionData ? this.sessionData.typePerson : '', Validators.required],
    });
    this.filterFile();
    if (this.sessionData?.typePerson) {
      this.selectPersonType(this.sessionData?.typePerson);
    }
  }

  filterFile(): void {
    let infoUpload: UploadScreenTaxInfo = {
      fileFrontCI: undefined,
      fileBackCI: undefined,
      ciValidationRequired: true,
    };

    this.taxService.getUploadFileTaxInfo().subscribe((data) => {
      console.log('dataFILTERFILE', JSON.stringify(data));
      infoUpload = data;
      // Aquí puedes realizar cualquier otra lógica que dependa de infoUpload
      // Por ejemplo, actualizar el formulario con los datos recibidos.
      this.updateFormWithUploadInfo(infoUpload);
    });

    // No devuelvas infoUpload aquí, ya que aún no está definido
  }

  updateFormWithUploadInfo(infoUpload: UploadScreenTaxInfo): void {
    // Actualiza tu formulario con los datos recibidos
    this.taxForm.patchValue({
      fileFrontCi: infoUpload.fileFrontCI ? infoUpload.fileFrontCI : '',
      fileBackCi: infoUpload.fileBackCI ? infoUpload.fileBackCI : '',
    });
  }

  ngOnInit(): void {
    this.formValueChanges();
  }

  ngOnDestroy(): void {
    if (this.bucketSubscription) {
      this.bucketSubscription.unsubscribe();
    }
  }

  formValueChanges() {
    this.taxForm.controls['fileFrontCi'].valueChanges.subscribe(() => {
      this.ocrValidation('fileInput');
    });
    this.taxForm.controls['fileBackCi'].valueChanges.subscribe(() => {
      this.fileService.hideSpinner();
    });
    this.taxForm.controls['ruc'].valueChanges.subscribe(() => {
      this.changeRuc();
    });
    this.taxForm.controls['ci'].valueChanges.subscribe(() => {
      this.changeCi();
    });
    this.taxForm.controls['typePerson'].valueChanges.subscribe(() => {
      this.selectPersonType(this.taxForm.controls['typePerson'].value);
    });

    this.taxForm.controls['name'].valueChanges.subscribe((value) => {
      this.taxForm.controls['name'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });

    this.taxForm.controls['surname'].valueChanges.subscribe((value) => {
      this.taxForm.controls['surname'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });

    this.taxForm.controls['socialReason'].valueChanges.subscribe((value) => {
      this.taxForm.controls['socialReason'].setValue(value.toUpperCase(), {
        emitEvent: false,
      });
    });
  }

  back() {
    this.onBack.emit();
  }

  agregarGuion(value: string) {
    if (value.length > 5) {
      console.log('ruc function');
      const guionesAntiguos = value.match(/-/g) || [];
      const cantidadGuiones = guionesAntiguos.length;
      if (cantidadGuiones > 0) {
        value = value.replace(/-/g, '');
      }
      let legnth = value.length - 1;
      value = value.slice(0, legnth) + '-' + value.slice(legnth);
      this.taxForm.controls['ruc'].setValue(value, {
        emitEvent: false,
      });
    }
  }

  changeRuc() {
    this.loading = false;
    let ruc = this.taxForm.controls['ruc'].value;
    let validValue = ruc.replace(/[^0-9\-]/g, ' ');
    if (ruc !== validValue) {
      this.taxForm.controls['ruc'].setValue(validValue);
      this.taxForm.controls['ruc'].setValue(validValue.trim());
    }
    this.agregarGuion(ruc);
  }

  changeCi() {
    this.loading = false;
    let ci = this.taxForm.controls['ci'].value;
    if (ci.length == 7) {
      this.validateOcrCount = 0;
      this.ocrValidation('ciInput');
    }
  }

  ocrValidation(from: string) {
    let ci: string = '';
    if (this.taxForm.controls['ci'].value) ci = this.taxForm.controls['ci'].value;
    let file: FileSave[] = this.taxForm.controls['fileFrontCi'].value;
    if (file?.[0]?.file) {
      let src = file[0].src.replace(/^data:image\/[a-z]+;base64,/, '');
      this.fileService.validateOcr(src, ci).subscribe(
        (data) => {
          if (data.message == 202) this.ocrValidationFail(from);
          else this.ocrValidationCorrect(data);
        },
        (error) => {
          this.ocrValidationFail(from);
        },
      );
    }
  }

  selectPersonType(event: any) {
    console.log('select person');
    this.typePerson = event;
    if (this.typePerson == TypePerson.FISICA) {
      this.personIsFisica();
    } else if (this.typePerson == TypePerson.JURIDICA) {
      this.personIsJuridica();
    }
  }

  personIsFisica() {
    const patternCI: RegExp = /^[a-zA-Z0-9]+$/;
    this.changeControlsValidations('ci', true, 8, 6, patternCI);
    this.changeControlsValidations('fileFrontCi', true);
    this.changeControlsValidations('fileBackCi', true);
    this.changeControlsValidations('name', true);
    this.changeControlsValidations('surname', true);
    this.changeControlsValidations('ruc', false);
    this.changeControlsValidations('socialReason', false);
    this.validateOcrCount = 0;
    this.ocrError = false;
  }

  personIsJuridica() {
    const patternCI: RegExp = /^[a-zA-Z0-9]+$/;
    this.changeControlsValidations('ci', true, 8, 6, patternCI);
    this.changeControlsValidations('fileFrontCi', false);
    this.changeControlsValidations('fileBackCi', false);
    this.changeControlsValidations('name', true);
    this.changeControlsValidations('surname', true);
    this.changeControlsValidations('ruc', true);
    this.changeControlsValidations('socialReason', true);
  }

  ocrValidationCorrect(data: any) {
    console.log('ocr correct');
    this.ocrError = false;
  }

  ocrValidationFail(from: string) {
    if (this.validateOcrCount >= 1) {
      this.ocrError = false;
    } else {
      console.log('ocr error', this.taxForm.controls['fileFrontCi'].value);
      this.bucketSubscription = this.bucketService
        .deleteFileBucket(this.taxForm.controls['fileFrontCi'].value[0]?.name)
        .subscribe(() => console.log('El documento se eliminó correctamente'));
      this.taxForm.controls['fileFrontCi'].reset();
      this.ocrError = true;
      if (from == 'fileInput') {
        this.validateOcrCount++;
      }
    }
  }

  changeControlsValidations(control: string, required: boolean, max?: number, min?: number, pattern?: RegExp) {
    if (required) {
      this.taxForm.controls[control].addValidators(Validators.required);
      if (max) {
        this.taxForm.controls[control].addValidators(Validators.maxLength(max));
      }
      if (min) {
        this.taxForm.controls[control].addValidators(Validators.minLength(min));
      }
      if (pattern) {
        this.taxForm.controls[control].addValidators(Validators.pattern(pattern));
      }
    } else {
      this.taxForm.controls[control].clearValidators();
      this.taxForm.controls[control].setErrors(null);
      this.taxForm.controls[control].setValue('');
    }
    this.taxForm.controls[control].updateValueAndValidity();
  }

  onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      if (this.taxForm.valid) {
        this.saveAndValidated();
      }
    }
  }

  saveAndValidated() {
    let numIdem;
    if (this.taxForm.controls['typePerson'].value == 'F') {
      numIdem = this.taxForm.controls['ci'].value;
    } else {
      numIdem = this.taxForm.controls['ruc'].value;
    }
    this.taxService.getDuplicated(numIdem, this.potentialCustomerData?.location.street).subscribe((data) => {
      if (data) {
        this.isDuplicated = true;
        this.warningCuitText =
          'Registramos una solicitud abierta para este Nro de Cuit. Por favor esperar al tratamiento de la misma. Cualquier duda contactar al centro de servicios al cliente. Gracias!';
        this.errorDiv?.nativeElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        this.saveInfoTaxValidation();
      }
    });
  }

  saveInfoTaxValidation() {
    this.loading = true;
    let data: TaxValidation = this.createTaxDto();

    if (!this.taxForm.controls['ci'].value || Number(this.taxForm.controls['ci'].value) > 0) {
      this.sesion.setItem('tax_validation', data);
      let fileDoc: FileDto[] = [
        { files: this.taxForm.controls['fileFrontCi'].value },
        { files: this.taxForm.controls['fileBackCi'].value },
      ];

      let uploadCache: UploadScreenTaxInfo = {
        fileFrontCI: this.taxForm.controls['fileFrontCi'].value,
        fileBackCI: this.taxForm.controls['fileBackCi'].value,
        ciValidationRequired: this.ocrError,
      };
      let upload: UploadScreenInfo = {
        fileDoc: fileDoc,
        ciValidationRequired: this.ocrError,
      };
      this.serviceUploadFile.saveFiles(upload);
      this.taxService.saveFilesTaxInfo(uploadCache);
      this.formComplete();
    }
  }

  createTaxDto(): TaxValidation {
    let data: TaxValidation = {
      ci: this.taxForm.controls['ci'].value,
      ruc: this.taxForm.controls['ruc'].value,
      name: this.taxForm.controls['name'].value,
      surname: this.taxForm.controls['surname'].value,
      typePerson: this.taxForm.controls['typePerson'].value,
      socialReason: this.taxForm.controls['socialReason'].value,
    };
    return data;
  }

  formComplete() {
    if (this.taxForm.controls['typePerson'].value == 'F') {
      this.onComplete.emit(6);
    } else {
      this.onComplete.emit(5);
    }
  }
}
